/**
 * Created by Mark on 18/12/2016.
 */

import ApplicationServices from './base-service.js';

class  StatisticsService {
    getAccountGeneralStatistics(){
        return ApplicationServices.call("statisticsController/getGeneralStatistics",
                {isAccount:true});
    };

    getAccountRanking(){
        return ApplicationServices.call("userDataController/getUserScore",
                {number:2});
    };

    getAccountStudentRanking(){
        return ApplicationServices.call("userDataController/getUserStudentOnlyScore", {number:30});
    };

    getAccountLearnt(){
        return ApplicationServices.call("statisticsController/getLearntValues",
                {isAccount:true, timeValue:new Date().getTime()});
    };

    getAccountAverageValues(){
        return ApplicationServices.call("statisticsController/getAverageValues",
                {isAccount:true});
    };

    getClassGeneralStatistics(classUid){
        return ApplicationServices.call("statisticsController/getGeneralStatistics",
                {classUid:classUid});
    };

    getClassRanking(classUid){
        return ApplicationServices.call("userDataController/getUserScore",
                {classUid:classUid});
    };

    getClassLearnt(classUid){
        return ApplicationServices.call("statisticsController/getLearntValues",
                {classUid:classUid, timeValue:new Date().getTime()});
    };

    getClassAverageValues(classUid){
        return ApplicationServices.call("statisticsController/getAverageValues",
                {classUid:classUid});
    };

    getUserGeneralStatistics(userUid){
        return ApplicationServices.call("statisticsController/getGeneralStatistics",
                {userUid:userUid});
    };

    getUserRanking(userUid){
        return ApplicationServices.call("userDataController/getUserScore",
                {userUid:userUid, cached:true});
    };

    getUserLearnt(userUid){
        return ApplicationServices.call("statisticsController/getLearntValues",
                {userUid:userUid, timeValue:new Date().getTime()});
    };

    getUserAverageValues(userUid){
        return ApplicationServices.call("statisticsController/getAverageValues",
                {userUid:userUid});
    };

}

export default new StatisticsService();